/**
 * Utility functions for detecting and handling Apple private relay emails
 */

/**
 * Check if an email is using Apple's private relay
 * @param email - The email address to check
 * @returns true if the email is a private relay email
 */
export function isApplePrivateRelay(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.endsWith("@privaterelay.appleid.com");
}

/**
 * Check if a provider ID is Apple
 * @param providerId - The provider ID to check
 * @returns true if the provider is Apple
 */
export function isAppleProvider(providerId: string): boolean {
  return providerId === "apple.com";
}

/**
 * Get a user-friendly description of the private relay email
 * @param email - The private relay email
 * @returns A formatted string explaining the private relay
 */
export function getPrivateRelayDescription(email: string): string {
  return `Apple Private ID (${email.split("@")[0].slice(0, 8)}...)`;
}

/**
 * Check if user should see account linking suggestion
 * @param email - User's email
 * @param linkedProviders - Array of linked provider IDs
 * @returns true if should show linking suggestion
 */
export function shouldSuggestAccountLinking(
  email: string | null | undefined,
  linkedProviders: string[],
): boolean {
  // Show suggestion if using Apple private relay and only has one provider
  return isApplePrivateRelay(email) && linkedProviders.length === 1;
}
